export class LatestBalanceModel {
  balanceDate: Date;
  balance?: number;
  id: number;
}
